import { Controller, UseFormReturn } from "react-hook-form";
import { FieldProps } from "../../renderFieldInput";
import {
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    FormHelperText,
} from "@mui/material";
import { useFields } from "../../../../api/useFields";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { parseISO } from "date-fns";
import pt from "date-fns/locale/pt";

interface OrdersPaymentsFilterFieldProps extends FieldProps {
    entityForm: UseFormReturn;
}

export const OrdersPaymentsFilterField = ({
    field,
    entityForm,
    options,
    extraOptions,
}: OrdersPaymentsFilterFieldProps) => {
    const { formatedFields: fieldsData } = useFields("orders_payments");

    const paymentMethodField = fieldsData?.find(
        (f: any) => f.field === "payment_method"
    );

    const choices = paymentMethodField?.settings?.options?.choices || [];

    return (
        <Controller
            name={extraOptions?.field ? extraOptions?.field : field.field}
            control={entityForm.control}
            defaultValue=""
            render={({ field: inputField }) => (
                <FormControl fullWidth error={options?.error}>
                    <InputLabel>{field.headerName}</InputLabel>
                    <Select
                        {...inputField}
                        label={field.headerName}
                        disabled={options?.disabled}
                    >
                        {choices.map((choice: any) => (
                            <MenuItem key={choice.value} value={choice.value}>
                                {choice.text}
                            </MenuItem>
                        ))}
                    </Select>
                    <FormHelperText>{options?.helperText}</FormHelperText>
                </FormControl>
            )}
        />
    );
};

type OrdersPaymentsDateFilterFieldProps = {
    field: FieldProps["field"];
    entityForm: UseFormReturn;
    options?: FieldProps["options"];
    extraOptions?: FieldProps["extraOptions"];
};

export const OrdersPaymentsDateFilterField = ({
    field,
    entityForm,
    options,
    extraOptions,
}: OrdersPaymentsDateFilterFieldProps) => {
    const fieldName = extraOptions?.field ? extraOptions?.field : field.field;

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pt}>
            <Controller
                name={fieldName}
                control={entityForm.control}
                defaultValue={null}
                render={({ field: inputField }) => (
                    <DatePicker
                        {...inputField}
                        value={
                            inputField.value
                                ? typeof inputField.value === "string"
                                    ? parseISO(inputField.value)
                                    : inputField.value
                                : null
                        }
                        disabled={options?.disabled}
                        format="dd/MM/yyyy"
                        label={field.headerName}
                        sx={{ width: "100%" }}
                    />
                )}
            />
        </LocalizationProvider>
    );
};
